import { render, staticRenderFns } from "./MemberBusinessCard.vue?vue&type=template&id=8267a3f8&scoped=true&"
import script from "./MemberBusinessCard.vue?vue&type=script&lang=js&"
export * from "./MemberBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./MemberBusinessCard.vue?vue&type=style&index=0&id=8267a3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8267a3f8",
  null
  
)

export default component.exports